import { motion } from "framer-motion";
import { fadeUp } from "./motion";

const chapters = [
  {
    n: "01",
    accent: "text-[#EAB308]",
    title: "Misión",
    text: "Desarrollar, posicionar y distribuir marcas emergentes de accesorios deportivos en los mercados de América Latina y el Caribe.",
  },
  {
    n: "02",
    accent: "text-[#DB2777]",
    title: "Visión",
    text: "Construir la plataforma regional dedicada exclusivamente a escalar marcas de alto potencial, llevándolas a mercados donde antes no tenían presencia.",
  },
  {
    n: "03",
    accent: "text-white",
    title: "Enfoque",
    text: "Distribución estratégica, expansión retail, activaciones y eventos, y construcción de comunidades locales leales alrededor de cada marca.",
  },
];

const Manifesto = () => (
  <section id="manifiesto" className="relative py-24 lg:py-36 px-6 lg:px-12 bg-[#0A0A0A] text-white overflow-hidden" data-testid="manifesto-section">
    <span aria-hidden className="absolute -top-8 right-0 font-display font-bold uppercase tracking-tighter text-[22vw] leading-none text-white/[0.04] select-none pointer-events-none">
      Rocky
    </span>
    <div className="max-w-[1600px] mx-auto relative">
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        className="flex items-baseline gap-6 mb-16 lg:mb-24"
      >
        <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#EAB308]">Quiénes somos</span>
        <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl">
          Manifiesto
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-y-16 gap-x-8">
        {chapters.map((c, i) => (
          <motion.article
            key={c.n}
            custom={i}
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            className="md:col-span-4 border-t border-white/15 pt-8 group"
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <span className={`font-serif-accent text-6xl lg:text-7xl block mb-6 ${c.accent} group-hover:translate-x-2 transition-transform duration-500 ease-out`}>
              {c.n}
            </span>
            <h3 className="font-display font-bold uppercase tracking-tight text-2xl mb-4">{c.title}</h3>
            <p className="text-base leading-relaxed text-white/55">{c.text}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
